module.exports = __webpack_public_path__ + "static/media/mail_arrow.8023cd0b.svg";